import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  naicCode: null,
  memberName: null,
  status: null,
  statusIds: [],
  assessmentDate: null,
  assessmentClass: null,
  assessmentId: null,
  invoiceNumber: null,
  emailStatus: null,
  communicationType: null,
  communicationDate: null,
  emailDate: null,
  isActive: null,
  email: null,
  groupName: null,
  memberEmail: null,
  activeTab:0,
  paymentReceivedDate: null,
  paymentOpenStatus: null,
  merged: null,
  suspWith: null,
  insolvent: null,
}

const filterSlice = createSlice({
    name: "filterSlice",
    initialState,
    reducers: {
      setNaicCode: (state, action) => {
        state.naicCode = action.payload
      },
      setMemberName: (state, action) => {state.memberName = action.payload},
  setStatus: (state, action) => {state.status = action.payload},
  setStatusIds: (state, action) => {state.statusIds = action.payload},
      setAssessmentDate: (state, action) => {state.assessmentDate = action.payload},
      setAssessmentId: (state, action) => {state.assessmentId = action.payload},
      setAssessmentClass: (state, action) => {state.assessmentClass = action.payload},
      setInvoiceNumber: (state, action) => {state.invoiceNumber = action.payload?.toString()},
      setEmailStatus: (state, action) => {state.emailStatus = action.payload},
      setCommunicationType: (state, action) => {state.communicationType = action.payload},
      setCommunicationDate: (state, action) => {state.communicationDate = action.payload},
      setIsActive: (state, action) => {state.isActive = action.payload},
      setEmail: (state, action) => {state.email = action.payload},
      setEmailDate: (state, action) => {state.emailDate = action.payload},
      setGroupName: (state, action) => {state.groupName = action.payload},
      setMemberEmail: (state, action) => {state.memberEmail = action.payload},
      setActiveTab: (state, action) => {state.activeTab = action.payload},
      setPaymentReceivedDate: (state, action) => {state.paymentReceivedDate = action.payload},
      setPaymentOpenStatus: (state, action) => {state.paymentOpenStatus = action.payload},
  setMerged: (state, action) => {state.merged = action.payload},
  setSuspWith: (state, action) => {state.suspWith = action.payload},
  setInsolvent: (state, action) => {state.insolvent = action.payload},
    }
  });
  
  
  export const {
    setNaicCode,
    setMemberName,
    setEmail,
    setStatus,
    setStatusIds,
    setAssessmentDate,
    setAssessmentClass,
    setAssessmentId,
    setInvoiceNumber,
    setEmailStatus,
    setCommunicationType,
    setCommunicationDate,
    setIsActive,
    setEmailDate,
    setGroupName,
    setMemberEmail,
    setActiveTab,
    setPaymentOpenStatus,
    setPaymentReceivedDate,
  setMerged,
  setSuspWith,
  setInsolvent,
  } =  filterSlice.actions;
  export default filterSlice.reducer